module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-adapter@2x.93ea224e.jpg";